export default __webpack_public_path__ + "static/alpaca-finance-0c49832bb6b8a7d534df0572f3017704.png";